import { WorkingElement } from '@/pages/consultant/consultantHours/calendar/calendar.styles';
import { CALENDAR_ELEMENTS_CONFIG } from '../constants/calendarElementsConfig';

export const calculateCalendatElementsBaner = (e) =>
	CALENDAR_ELEMENTS_CONFIG.filter((el) => e[el.field]).map((el) => (
		<WorkingElement style={{ background: el.background }}>
			{el.text} {e[el.field]}h
		</WorkingElement>
	));
